<template>
  <div id="mainContainer" :dir="setDirection">
    <div id="loader" v-show="isLoading"><div class="loader"></div></div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    setDirection() {
      document.querySelector("body").classList.add("rtl");
      return "rtl";
    },
  },
  created() {
    let windowHeight = window.innerHeight + "px";
    document.querySelector("body").style.cssText =
      `height: ` + windowHeight + ``;
  },
};
</script>

<style>
#mainContainer {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
}
</style>
